import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class ServicesSidebar extends Component {
    render() {
        return (
            <div className="widget widget-nav-menu">
                <ul className="widget-menu">
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-membership'}>Membership</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-circulation'}>Circulation</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-bookbank'}>Book Bank</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-referencesection'}> Reference Section </NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-periodicalssection'}>Periodicals Section </NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-readingroom'}> Reading Room </NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-departmentlibraries'}>Department Libraries </NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-userawareness'}>User Awareness  </NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-emailalert'}>E-Mail Alert </NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-activities'}>Activities & Reports </NavLink></li>
                </ul>
            </div>
        )
    }
}
